import styled from 'styled-components';
import colors from '../../../../../helpers/colors';
import fonts from '../../../../../helpers/fonts';
import spacing from '../../../../../helpers/spacing';
import RichText from '../../../../RichText';

const Alert = styled(RichText)`
  ${fonts.paragraph}
  padding: ${spacing(2)};
  margin: ${spacing(1)} 0;

  display: inline-block;

  border-radius: ${({ theme }) => `${theme.cardRadius}`};
  border: 1px solid ${colors.notificationWarning};
`;

export default Alert;
